<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <Card :title="'Buat Perjanjian'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'appointments'"
              :purpose="'add'"
            />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/appointments/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  name: 'Add',

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        room_id: '',
        patient_id: '',
        doctor_id: '',
        action_type_id: '',
        date: '',
        doctor_time_slot_id: '',
        live_meeting_link: '',
        appointment_status_id: '',
        notes: '',
      },
    }
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Perjanjian" },
      { title: "Buat Janji" },
    ])
  },

}
</script>

<style>
</style>